import { Box, Button, Stack, Typography } from "@mui/material";
import TextFieldControl from "components/form/TextFieldControl";
import { FieldArrayWithId, UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn } from "react-hook-form";
import { Add } from "@mui/icons-material";
import VALIDATION from "helpers/validation";
import SkillsList from "../SkillsList";
import { CompetencyLiteralType, CompetencyMapInputs, SkillsLiteralType } from "../types";
import { TEXT_FIELD_SX, TYPOGRAPHY_TITLE_SX } from "../constants";

interface IKnowledgeBlockBodyProps {
  name: CompetencyLiteralType;
  isEditable: boolean;
  form: UseFormReturn<CompetencyMapInputs>;
  skillsFields: FieldArrayWithId<CompetencyMapInputs, SkillsLiteralType, "skillId">[];
  removeSkill: UseFieldArrayRemove;
  appendSkill: UseFieldArrayAppend<CompetencyMapInputs, SkillsLiteralType>;
}

const KnowledgeBlockBody = ({
  name,
  isEditable,
  skillsFields,
  appendSkill,
  removeSkill,
  form,
}: IKnowledgeBlockBodyProps) => {
  const knowledgeBlock = form.getValues(name);

  const addSkillBlock = () => {
    appendSkill({ title: "", grades: [] });
  };

  return (
    <Box>
      <Stack
        direction='row'
        spacing={2}
        sx={{ alignItems: "center", marginBottom: 3 }}>
        <Typography
          variant='subtitle1'
          sx={{ ...TYPOGRAPHY_TITLE_SX }}>
          Профессия
        </Typography>
        <TextFieldControl
          placeholder='Название профессии'
          name={`${name}.profession`}
          disabled={!isEditable || Boolean(knowledgeBlock.id)}
          rules={{ required: true, ...VALIDATION.competencyMapTitle }}
          color='secondary'
          stackSx={{ ...TEXT_FIELD_SX }}
        />
      </Stack>
      <SkillsList
        name={`${name}.skills`}
        isEditable={isEditable}
        skills={skillsFields}
        removeSkill={removeSkill}
        knowledgeBlock={knowledgeBlock}
      />
      <Button
        startIcon={<Add sx={{ color: "base.200" }} />}
        variant='contained'
        color='secondary'
        onClick={addSkillBlock}
        disabled={!isEditable}
        sx={{
          mt: 2,
          backgroundColor: "#fff",
          "&:hover": { backgroundColor: "#fff" },
          "&:active": { backgroundColor: "#fff" },
          "&.Mui-disabled": { backgroundColor: "#fff" },
        }}>
        Навык
      </Button>
    </Box>
  );
};

export default KnowledgeBlockBody;
